(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-seller"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSort(select) {
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function getCartUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + 'cart.js';
    }
    return '/cart.js';
  }

  function tryOpenCartDrawer() {
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    }

    var drawer = document.querySelector(
      'cart-drawer, cart-notification, #CartDrawer, #cart-drawer, .cart-drawer, [data-cart-drawer]'
    );

    if (drawer) {
      if (typeof drawer.open === 'function') {
        drawer.open();
      } else if (typeof drawer.renderContents === 'function') {
        fetch(getCartUrl())
          .then(function (res) { return res.json(); })
          .then(function (cart) { drawer.renderContents(cart); });
      } else {
        drawer.classList.add('is-open', 'active', 'open');
        drawer.setAttribute('open', '');
      }
    }
  }

  /* ───────────────────────────────────────────────────────────
     Best Sellers carousel: nav arrows + drag-to-scroll
  ─────────────────────────────────────────────────────────── */
  function initBestSellersCarousel(root) {
    var track = root.querySelector('.best-sellers__track');
    if (!track || track.dataset.bsInit === 'true') return;
    track.dataset.bsInit = 'true';

    var prevBtn = root.querySelector('.best-sellers__nav--prev');
    var nextBtn = root.querySelector('.best-sellers__nav--next');

    function getStep() {
      var card = track.querySelector('.product-card');
      if (!card) return track.clientWidth;
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateNavState, 60);
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateNavState, 100);
    });

        /* Drag to scroll (mouse / pen). Touch keeps native scrolling. */
    var isDown = false;
    var dragged = false;
    var startX = 0;
    var startScrollLeft = 0;
    var activePointerId = null;
    var captured = false;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      isDown = true;
      dragged = false;
      captured = false;
      startX = e.clientX;
      startScrollLeft = track.scrollLeft;
      activePointerId = e.pointerId;
      // NOTE: pointer capture ekhane NEWA hocche na — shudhu drag shuru hole nibo
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown || e.pointerId !== activePointerId) return;
      var dx = e.clientX - startX;

      if (!dragged && Math.abs(dx) > 3) {
        dragged = true;
        track.classList.add('is-dragging');
        // drag confirm howar por e capture newa hocche, click er age na
        try {
          track.setPointerCapture(e.pointerId);
          captured = true;
        } catch (err) {}
      }

      if (dragged) {
        track.scrollLeft = startScrollLeft - dx;
      }
    });

    function endDrag(e) {
      if (!isDown) return;
      if (captured && e && activePointerId !== null) {
        try { track.releasePointerCapture(activePointerId); } catch (err) {}
      }
      isDown = false;
      captured = false;
      activePointerId = null;
      track.classList.remove('is-dragging');
      updateNavState();
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', function (e) {
      if (isDown) endDrag(e);
    });

    /* Prevent a click firing right after a drag (so add-to-cart / links
       don't misfire when user was just dragging the carousel). */
    track.addEventListener(
      'click',
      function (e) {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
          dragged = false;
        }
      },
      true
    );

    updateNavState();
  }

  function initAllBestSellers() {
    document.querySelectorAll('.best-sellers').forEach(initBestSellersCarousel);
  }

  function init() {
    document.querySelectorAll('.collection-page__sort-select').forEach(initSort);
    initAllBestSellers();
  }

  document.addEventListener('product-card:added', function (e) {
    document.dispatchEvent(
      new CustomEvent('cart:item-added', {
        bubbles: true,
        detail: { item: e.detail && e.detail.item }
      })
    );
    tryOpenCartDrawer();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on section reload in theme editor (e.g. when settings change)
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.best-sellers');
    if (section) initBestSellersCarousel(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSearch(root) {
    var input = root.querySelector('[data-collection-search]');
    var grid  = root.querySelector('[data-collections-grid]');
    var noResults = root.querySelector('[data-no-results]');
    var visibleCountEl = root.querySelector('[data-visible-count]');
    if (!input || !grid) return;

    var cards = grid.querySelectorAll('[data-collection-card]');

    input.addEventListener('input', function () {
      var query = input.value.trim().toLowerCase();
      var visibleCount = 0;

      cards.forEach(function (card) {
        var title = card.getAttribute('data-collection-title') || '';
        var matches = title.indexOf(query) !== -1;
        card.hidden = !matches;
        if (matches) visibleCount++;
      });

      if (visibleCountEl) visibleCountEl.textContent = visibleCount;
      if (noResults) noResults.hidden = visibleCount !== 0;
    });
  }

  function init() {
    document.querySelectorAll('.collections-page').forEach(initSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init() {
    var form = document.getElementById('ContactForm');
    if (!form) return;

    form.addEventListener('submit', function () {
      var btn = form.querySelector('.contact-page__submit');
      if (btn) btn.classList.add('is-sending');
    });

    // Auto-scroll to success/error alert if present
    var alertBox = document.querySelector('[data-contact-alert]');
    if (alertBox) {
      alertBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    function initHeader(headerEl) {
      var sectionId = headerEl.dataset.sectionId;
      var config = (window.HeaderSection && window.HeaderSection[sectionId]) || {};
      var stickyEnable = headerEl.dataset.stickyEnable === 'true';

      if (stickyEnable) {
        var headerInner = headerEl.querySelector('.site-header__inner');
        var spacer = document.createElement('div');
        spacer.className = 'site-header--sticky-spacer';
        spacer.style.display = 'none';
        headerInner.parentNode.insertBefore(spacer, headerInner);

        var triggerPoint = 0;
        var isSticky = false;
        var stickyTicking = false;

        function calcTriggerPoint() {
          if (isSticky) return;
          triggerPoint = headerEl.getBoundingClientRect().top + window.pageYOffset;
        }
        function updateSticky() {
          var scrollY = window.pageYOffset || document.documentElement.scrollTop;
          var shouldStick = scrollY > triggerPoint + 2;
          if (shouldStick !== isSticky) {
            isSticky = shouldStick;
            if (isSticky) {
              spacer.style.height = headerInner.getBoundingClientRect().height + 'px';
              spacer.style.display = 'block';
              headerEl.classList.add('site-header--is-sticky');
            } else {
              headerEl.classList.remove('site-header--is-sticky');
              spacer.style.display = 'none';
            }
          }
          stickyTicking = false;
        }
        calcTriggerPoint();
        updateSticky();
        window.addEventListener(
          'scroll',
          function () {
            if (!stickyTicking) {
              window.requestAnimationFrame(updateSticky);
              stickyTicking = true;
            }
          },
          { passive: true }
        );
        window.addEventListener('resize', function () {
          calcTriggerPoint();
          updateSticky();
        });
      }

      var announcementBar = headerEl.querySelector('#AnnouncementBar-' + sectionId);
      if (announcementBar) {
        var slides = announcementBar.querySelectorAll('.announcement-bar__slide');
        var current = 0;
        var timer = null;
        var autoplay = announcementBar.dataset.autoplay === 'true';
        var speed = parseInt(announcementBar.dataset.speed, 10) || 4000;
        if (slides.length) {
          slides[0].classList.add('is-active');
        }
        function goToSlide(index) {
          if (slides.length < 2) return;
          var prev = current;
          current = index % slides.length;
          slides[prev].classList.add('is-leaving');
          slides[prev].classList.remove('is-active');
          slides[current].classList.remove('is-leaving');
          void slides[current].offsetWidth;
          slides[current].classList.add('is-active');
          window.setTimeout(function () {
            slides[prev].classList.remove('is-leaving');
          }, 650);
        }
        function startAutoplay() {
          if (!autoplay || slides.length < 2) return;
          stopAutoplay();
          timer = window.setInterval(function () {
            goToSlide(current + 1);
          }, speed);
        }
        function stopAutoplay() {
          if (timer) {
            window.clearInterval(timer);
            timer = null;
          }
        }
        startAutoplay();
        announcementBar.addEventListener('mouseenter', stopAutoplay);
        announcementBar.addEventListener('mouseleave', startAutoplay);
        announcementBar.addEventListener('focusin', stopAutoplay);
        announcementBar.addEventListener('focusout', startAutoplay);
      }

      var dropdownItems = headerEl.querySelectorAll('.nav-menu__item--has-dropdown');
      dropdownItems.forEach(function (item) {
        var closeTimer = null;
        var dropdown = item.querySelector('.nav-dropdown');

        function positionDropdown() {
          if (!dropdown) return;
          dropdown.classList.remove('nav-dropdown--edge-left', 'nav-dropdown--edge-right');
          var viewportWidth = window.innerWidth;
          dropdown.style.visibility = 'hidden';
          dropdown.style.opacity = '0';
          dropdown.style.pointerEvents = 'none';
          dropdown.style.transform = 'translate(-50%, 0)';
          window.requestAnimationFrame(function () {
            var r = dropdown.getBoundingClientRect();
            if (r.left < 8) {
              dropdown.classList.add('nav-dropdown--edge-left');
            } else if (r.right > viewportWidth - 8) {
              dropdown.classList.add('nav-dropdown--edge-right');
            }
            dropdown.style.visibility = '';
            dropdown.style.opacity = '';
            dropdown.style.pointerEvents = '';
            dropdown.style.transform = '';
          });
        }

        function openDropdown() {
          if (closeTimer) {
            window.clearTimeout(closeTimer);
            closeTimer = null;
          }
          positionDropdown();
          item.classList.add('is-dropdown-open');
        }
        function scheduleClose() {
          if (closeTimer) window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(function () {
            item.classList.remove('is-dropdown-open');
            closeTimer = null;
          }, 250);
        }

        item.addEventListener('mouseenter', openDropdown);
        item.addEventListener('mouseleave', scheduleClose);
        item.addEventListener('focusin', openDropdown);
        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) scheduleClose();
        });
      });

      var searchToggle = headerEl.querySelector('#SearchToggle-' + sectionId);
      var searchPanel = headerEl.querySelector('#SearchPanel-' + sectionId);
      var searchClose = headerEl.querySelector('#SearchClose-' + sectionId);
      function openSearch() {
        searchPanel.classList.add('is-open');
        searchToggle.setAttribute('aria-expanded', 'true');
        window.setTimeout(function () {
          var input = searchPanel.querySelector('.search-panel__input');
          if (input) input.focus();
        }, 200);
      }
      function closeSearch() {
        searchPanel.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
      }
      if (searchToggle && searchPanel) {
        searchToggle.addEventListener('click', function () {
          if (searchPanel.classList.contains('is-open')) {
            closeSearch();
          } else {
            openSearch();
          }
        });
        if (searchClose) searchClose.addEventListener('click', closeSearch);
      }

      var hamburger = headerEl.querySelector('#HamburgerBtn-' + sectionId);
      var mobileMenu = headerEl.querySelector('#MobileMenu-' + sectionId);
      var mobileOverlay = headerEl.querySelector('#MobileMenuOverlay-' + sectionId);
      var mobileClose = headerEl.querySelector('#MobileMenuClose-' + sectionId);

      var cartToggle = headerEl.querySelector('#CartToggle-' + sectionId);
      var cartDrawer = headerEl.querySelector('#CartDrawer-' + sectionId);
      var cartOverlay = headerEl.querySelector('#CartDrawerOverlay-' + sectionId);
      var cartClose = headerEl.querySelector('#CartDrawerClose-' + sectionId);
      var cartBody = headerEl.querySelector('#CartDrawerItems-' + sectionId);
      var cartEmpty = headerEl.querySelector('#CartDrawerEmpty-' + sectionId);
      var cartFooter = headerEl.querySelector('#CartDrawerFooter-' + sectionId);
      var cartLoading = headerEl.querySelector('#CartDrawerLoading-' + sectionId);
      var cartSubtotal = headerEl.querySelector('#CartDrawerSubtotal-' + sectionId);
      var cartCountEls = document.querySelectorAll('[data-cart-count]');

      var headerInlineStyle = headerEl.getAttribute('style') || '';
      [mobileOverlay, mobileMenu, cartOverlay, cartDrawer].forEach(function (el) {
        if (!el) return;
        if (headerInlineStyle) {
          el.setAttribute('style', (el.getAttribute('style') || '') + ';' + headerInlineStyle);
        }
        if (el.parentNode !== document.body) {
          document.body.appendChild(el);
        }
      });

      function openMobileMenu() {
        mobileMenu.classList.add('is-open');
        mobileOverlay.classList.add('is-open');
        hamburger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('menu-open');
        document.body.classList.add('menu-open');
      }
      function closeMobileMenu() {
        mobileMenu.classList.remove('is-open');
        mobileOverlay.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('menu-open');
        document.body.classList.remove('menu-open');
      }
      if (hamburger) hamburger.addEventListener('click', openMobileMenu);
      if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
      if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

      var accordionToggles = document.querySelectorAll('.mobile-accordion__toggle');
      accordionToggles.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var row = btn.closest('.mobile-accordion__row');
          var panel = row.nextElementSibling;
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!expanded));
          if (!panel) return;
          if (expanded) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      });

      function formatMoney(cents) {
        var amount = (cents / 100).toFixed(2);
        if (config.moneyFormat && config.moneyFormat.indexOf('{{amount}}') > -1) {
          return config.moneyFormat.replace('{{amount}}', amount);
        }
        return '$' + amount;
      }
      function setLoading(state) {
        if (!cartLoading) return;
        cartLoading.hidden = !state;
      }
      function getSizedImage(url, width) {
        if (!url) return '';
        try {
          var u = new URL(url, window.location.origin);
          u.searchParams.set('width', width);
          return u.toString();
        } catch (e) {
          return url;
        }
      }
      function renderCart(cart) {
        if (!cartBody) return;
        cartBody.innerHTML = '';
        if (!cart.items.length) {
          cartEmpty.hidden = false;
          cartFooter.style.display = 'none';
        } else {
          cartEmpty.hidden = true;
          cartFooter.style.display = 'block';
          cart.items.forEach(function (item) {
            var el = document.createElement('div');
            el.className = 'cart-item';
            el.dataset.key = item.key;
            var imgSrc = getSizedImage(item.image, 160);
            var subscriptionHtml = '';
            if (item.selling_plan_allocation) {
              subscriptionHtml =
                '<span class="cart-item__subscription">' +
                '<svg width="10" height="10" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M17 10a7 7 0 11-2.05-4.95M17 3v4h-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                escapeHtml(item.selling_plan_allocation.selling_plan.name) +
                '</span>';
            }
            el.innerHTML =
              '<div class="cart-item__image">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '') +
              '</div>' +
              '<div class="cart-item__details">' +
              '<a href="' +
              item.url +
              '" class="cart-item__title">' +
              escapeHtml(item.product_title) +
              '</a>' +
              (item.variant_title
                ? '<span class="cart-item__variant">' + escapeHtml(item.variant_title) + '</span>'
                : '') +
              subscriptionHtml +
              '<div class="cart-item__qty">' +
              '<button type="button" class="cart-item__qty-btn" data-qty-decrease aria-label="Decrease quantity">\u2212</button>' +
              '<span class="cart-item__qty-value">' +
              item.quantity +
              '</span>' +
              '<button type="button" class="cart-item__qty-btn" data-qty-increase aria-label="Increase quantity">+</button>' +
              '</div>' +
              '</div>' +
              '<div class="cart-item__right">' +
              '<span class="cart-item__price">' +
              formatMoney(item.final_line_price) +
              '</span>' +
              '<button type="button" class="cart-item__remove" data-remove-item>Remove</button>' +
              '</div>';
            cartBody.appendChild(el);
          });
        }
        if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
        updateCartCount(cart.item_count);
      }
      function updateCartCount(count) {
        cartCountEls.forEach(function (el) {
          el.textContent = count;
          el.classList.add('is-bumped');
          window.setTimeout(function () {
            el.classList.remove('is-bumped');
          }, 400);
        });
      }
      function escapeHtml(str) {
        var div = document.createElement('div');
        div.textContent = str || '';
        return div.innerHTML;
      }
      function fetchCart() {
        setLoading(true);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            renderCart(cart);
            setLoading(false);
            return cart;
          })
          .catch(function () {
            setLoading(false);
          });
      }
      function changeItem(key, quantity) {
        setLoading(true);
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity }),
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            renderCart(cart);
            setLoading(false);
          })
          .catch(function () {
            setLoading(false);
          });
      }
      function openCartDrawer(skipFetch) {
        cartDrawer.classList.add('is-open');
        cartOverlay.classList.add('is-open');
        cartToggle.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('cart-open');
        document.body.classList.add('cart-open');
        if (!skipFetch) fetchCart();
      }
      function closeCartDrawer() {
        cartDrawer.classList.remove('is-open');
        cartOverlay.classList.remove('is-open');
        cartToggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('cart-open');
        document.body.classList.remove('cart-open');
      }
      if (cartToggle)
        cartToggle.addEventListener('click', function () {
          openCartDrawer();
        });
      if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
      if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
      document.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', closeCartDrawer);
      });
      if (cartBody) {
        cartBody.addEventListener('click', function (e) {
          var itemEl = e.target.closest('.cart-item');
          if (!itemEl) return;
          var key = itemEl.dataset.key;
          if (e.target.closest('[data-qty-increase]')) {
            var qtyEl = itemEl.querySelector('.cart-item__qty-value');
            changeItem(key, parseInt(qtyEl.textContent, 10) + 1);
          } else if (e.target.closest('[data-qty-decrease]')) {
            var qtyEl2 = itemEl.querySelector('.cart-item__qty-value');
            var newQty = parseInt(qtyEl2.textContent, 10) - 1;
            if (newQty <= 0) {
              itemEl.classList.add('is-removing');
              window.setTimeout(function () {
                changeItem(key, 0);
              }, 260);
            } else {
              changeItem(key, newQty);
            }
          } else if (e.target.closest('[data-remove-item]')) {
            itemEl.classList.add('is-removing');
            window.setTimeout(function () {
              changeItem(key, 0);
            }, 260);
          }
        });
      }
      document.addEventListener('product-card:added', function () {
      openCartDrawer();
      });

      var searchForms = headerEl.querySelectorAll('form[action*="/search"]');
      function debounce(fn, wait) {
        var t;
        return function () {
          var ctx = this, args = arguments;
          clearTimeout(t);
          t = setTimeout(function () { fn.apply(ctx, args); }, wait);
        };
      }
      searchForms.forEach(function (form) {
        var input = form.querySelector('input[type="search"]');
        var resultsContainer = form.querySelector('.predictive-search-results');
        if (!input || !resultsContainer) return;

        input.addEventListener('input', debounce(function () {
          var term = input.value.trim();
          if (term.length < 2) {
            resultsContainer.hidden = true;
            return;
          }

          fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=5')
            .then(function (res) { return res.json(); })
            .then(function (data) {
              var products = data.resources.results.products;
              if (!products || products.length === 0) {
                resultsContainer.innerHTML = '<div style="padding:16px;text-align:center;color:#888;font-size:14px;">No products found</div>';
                resultsContainer.hidden = false;
                return;
              }

              var html = '';
              products.forEach(function (product) {
                var imgHtml = product.image ? '<img src="' + getSizedImage(product.image, 100) + '" class="predictive-search-item__image" alt="">' : '<div class="predictive-search-item__image"></div>';
                var priceHtml = product.price ? '<span class="predictive-search-item__price">' + product.price + '</span>' : '';
                html += '<a href="' + product.url + '" class="predictive-search-item">' +
                          imgHtml +
                          '<div class="predictive-search-item__info">' +
                            '<span class="predictive-search-item__title">' + escapeHtml(product.title) + '</span>' +
                            priceHtml +
                          '</div>' +
                        '</a>';
              });
              
              html += '<a href="/search?q=' + encodeURIComponent(term) + '&type=product" class="predictive-search-view-all">View all results</a>';
              
              resultsContainer.innerHTML = html;
              resultsContainer.hidden = false;
            })
            .catch(function () {});
        }, 300));

        document.addEventListener('click', function(e) {
          if (!form.contains(e.target)) {
            resultsContainer.hidden = true;
          }
        });
        
        input.addEventListener('focus', function() {
          if (input.value.trim().length >= 2 && resultsContainer.innerHTML !== '') {
             resultsContainer.hidden = false;
          }
        });
      });

      document.addEventListener(
        'click',
        function (e) {
          if (cartDrawer && cartDrawer.classList.contains('is-open')) {
            var clickedInsideCart = cartDrawer.contains(e.target) || (cartToggle && cartToggle.contains(e.target));
            if (!clickedInsideCart) closeCartDrawer();
          }
          if (mobileMenu && mobileMenu.classList.contains('is-open')) {
            var clickedInsideMenu = mobileMenu.contains(e.target) || (hamburger && hamburger.contains(e.target));
            if (!clickedInsideMenu) closeMobileMenu();
          }
        },
        true
      );

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (mobileMenu && mobileMenu.classList.contains('is-open')) closeMobileMenu();
        if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCartDrawer();
        if (searchPanel && searchPanel.classList.contains('is-open')) closeSearch();
      });
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          updateCartCountSilently(cart.item_count);
        })
        .catch(function () {});
      function updateCartCountSilently(count) {
        cartCountEls.forEach(function (el) {
          el.textContent = count;
        });
      }
    }
    function init() {
      document.querySelectorAll('.site-header').forEach(initHeader);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var header = e.target.querySelector('.site-header');
      if (header) initHeader(header);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-releted-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  class RelatedProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      var url = this.getAttribute('data-url');
      if (!url) return;

      var self = this;

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var payload = doc.querySelector('[data-recommendations-payload]');
          var contentTarget = self.querySelector('[data-related-content]');
          var skeleton = self.querySelector('[data-skeleton]');

          if (skeleton) skeleton.remove();

          if (payload && payload.innerHTML.trim() !== '' && contentTarget) {
            contentTarget.innerHTML = payload.innerHTML;
            self.removeAttribute('hidden');
            self.initCarousel();
            self.initAddToCart();
          }
        })
        .catch(function () {
          var skeleton = self.querySelector('[data-skeleton]');
          if (skeleton) skeleton.remove();
        });
    }

    initCarousel() {
      var root  = this;
      var track = root.querySelector('[data-rp-track]');
      if (!track) return;

      var prevBtn = root.querySelector('[data-rp-prev]');
      var nextBtn = root.querySelector('[data-rp-next]');

      var mouseIsDown    = false;
      var dragStarted    = false;
      var startX         = 0;
      var startScrollLeft = 0;
      var velX           = 0;
      var lastX          = 0;
      var lastT          = 0;
      var moved          = false;
      var rafId          = null;
      var CLICK_THRESHOLD = 8;
      var FRICTION        = 0.93;
      var MIN_VEL         = 0.3;

      function cardStep() {
        var card = track.querySelector('.product-card');
        if (!card) return track.clientWidth * 0.8;
        var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        return card.offsetWidth + gap;
      }

      function clamp(val, min, max) { return Math.min(Math.max(val, min), max); }

      function updateNav() {
        if (!prevBtn || !nextBtn) return;
        var max = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = track.scrollLeft >= max - 1;
      }

      function stopMomentum() { cancelAnimationFrame(rafId); rafId = null; }

      function runMomentum() {
        if (Math.abs(velX) < MIN_VEL) {
          velX = 0;
          track.style.scrollSnapType = '';
          updateNav();
          return;
        }
        track.scrollLeft += velX;
        velX *= FRICTION;
        updateNav();
        rafId = requestAnimationFrame(runMomentum);
      }

      function engageDrag() {
        dragStarted = true;
        moved = true;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        track.classList.add('is-dragging');
      }

      var moveRafPending = false;
      var pendingClientX = 0;

      function applyMove() {
        moveRafPending = false;
        if (!mouseIsDown) return;

        var clientX = pendingClientX;
        var now = performance.now();
        var dt = Math.max(now - lastT, 1);
        var dx = clientX - startX;

        var instantVel = (clientX - lastX) / dt * 16;
        velX = velX * 0.6 + instantVel * 0.4;
        lastX = clientX;
        lastT = now;

        if (Math.abs(dx) > CLICK_THRESHOLD) moved = true;
        if (!dragStarted) {
          if (Math.abs(dx) > CLICK_THRESHOLD) { engageDrag(); } else { return; }
        }

        var maxScroll = track.scrollWidth - track.clientWidth;
        var newScroll = clamp(startScrollLeft - dx, 0, maxScroll);

        if (startScrollLeft - dx < 0) {
          newScroll = (startScrollLeft - dx) * 0.2;
          newScroll = Math.max(newScroll, -80);
        } else if (startScrollLeft - dx > maxScroll) {
          var over = (startScrollLeft - dx) - maxScroll;
          newScroll = maxScroll + over * 0.2;
          newScroll = Math.min(newScroll, maxScroll + 80);
        }

        track.scrollLeft = newScroll;
        updateNav();
      }

      function onDragMove(clientX) {
        if (!mouseIsDown) return;
        pendingClientX = clientX;
        if (!moveRafPending) {
          moveRafPending = true;
          requestAnimationFrame(applyMove);
        }
      }

      function onDragEnd() {
        if (!dragStarted) { mouseIsDown = false; return; }

        mouseIsDown = false;
        dragStarted = false;
        track.classList.remove('is-dragging');
        track.style.scrollBehavior = '';

        var maxScroll = track.scrollWidth - track.clientWidth;

        if (track.scrollLeft < 0 || track.scrollLeft > maxScroll) {
          track.style.scrollSnapType = '';
          track.style.scrollBehavior = 'smooth';
          track.scrollLeft = clamp(track.scrollLeft, 0, maxScroll);
          setTimeout(function () { track.style.scrollBehavior = ''; }, 400);
          velX = 0;
          return;
        }

        if (Math.abs(velX) > 1) {
          rafId = requestAnimationFrame(runMomentum);
        } else {
          track.style.scrollSnapType = '';
        }
      }

      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        stopMomentum();
        mouseIsDown = true;
        dragStarted = false;
        moved = false;
        startX = e.clientX;
        startScrollLeft = track.scrollLeft;
        lastX = e.clientX;
        lastT = performance.now();
        velX = 0;
      });

      window.addEventListener('mousemove', function (e) {
        if (!mouseIsDown) return;
        onDragMove(e.clientX);
      });

      window.addEventListener('mouseup', function () {
        if (!mouseIsDown) return;
        onDragEnd();
      });

      track.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopImmediatePropagation();
          moved = false;
        }
      }, true);

      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      track.addEventListener('touchstart', function () {
        stopMomentum();
        track.style.scrollSnapType = '';
        setTimeout(function () { track.style.scrollSnapType = 'x mandatory'; }, 50);
      }, { passive: true });

      function arrowScroll(dir) {
        stopMomentum();
        velX = 0;
        track.style.scrollSnapType = 'x mandatory';
        track.style.scrollBehavior = 'smooth';
        track.scrollBy({ left: dir * cardStep(), behavior: 'smooth' });
        setTimeout(function () {
          track.style.scrollBehavior = '';
          updateNav();
        }, 500);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { arrowScroll(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { arrowScroll(1); });

      track.addEventListener('scroll', function () {
        requestAnimationFrame(updateNav);
      }, { passive: true });

      window.addEventListener('resize', updateNav);
      updateNav();
    }

    initAddToCart() {
      var root = this;
      root.querySelectorAll('.product-card__form').forEach(function (form) {
        form.addEventListener('submit', function () {
          var btn = form.querySelector('.product-card__add-btn');
          if (btn) {
            btn.classList.add('is-adding');
            setTimeout(function () { btn.classList.remove('is-adding'); }, 900);
          }
        });
      });
    }
  }

  if (!customElements.get('related-products')) {
    customElements.define('related-products', RelatedProducts);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-search-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.search-page .product-card__form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('.product-card__add-btn');
        if (btn) {
          btn.classList.add('is-adding');
          setTimeout(function () { btn.classList.remove('is-adding'); }, 900);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-2"]) return;
  try {
    
(function () {
  'use strict';

  function initSort(select) {
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function getCartUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + 'cart.js';
    }
    return '/cart.js';
  }

  function tryOpenCartDrawer() {
    // 1) Custom function hook (jodi theme e globally thake)
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    }

    // 2) Common cart drawer selectors — apnar theme onujayi ekta match hobe
    var drawer = document.querySelector(
      'cart-drawer, cart-notification, #CartDrawer, #cart-drawer, .cart-drawer, [data-cart-drawer]'
    );

    if (drawer) {
      if (typeof drawer.open === 'function') {
        drawer.open();
      } else if (typeof drawer.renderContents === 'function') {
        // Dawn theme style hook
        fetch(getCartUrl())
          .then(function (res) { return res.json(); })
          .then(function (cart) { drawer.renderContents(cart); });
      } else {
        drawer.classList.add('is-open', 'active', 'open');
        drawer.setAttribute('open', '');
      }
    }
  }

  function init() {
    document.querySelectorAll('.collection-page__sort-select').forEach(initSort);
  }

  // NOTE: Add-to-cart submit handling (spinner, is-adding/is-added classes,
  // fetch to cart/add.js) is handled ONLY by the global listener inside
  // product-card.liquid snippet — we do NOT attach a second submit listener
  // here. We just listen for the event the snippet dispatches after a
  // successful add, and use it to open the cart drawer.
  document.addEventListener('product-card:added', function (e) {
    document.dispatchEvent(
      new CustomEvent('cart:item-added', {
        bubbles: true,
        detail: { item: e.detail && e.detail.item }
      })
    );
    tryOpenCartDrawer();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-2"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initProductPage(root) {
    if (root.dataset.ppInitialized === '1') return;
    root.dataset.ppInitialized = '1';

    var carousel   = root.querySelector('[data-main-carousel]');
    var thumbs     = root.querySelectorAll('[data-thumb]');
    var form       = root.querySelector('form[data-type="add-to-cart-form"], .product-page__form');
    var variantsEl = root.querySelector('[data-variants]');
    var variantIdInput = root.querySelector('[data-variant-id]');
    var addBtn     = root.querySelector('[data-add-btn]');
    var btnText    = root.querySelector('[data-btn-text]');
    var priceEl    = root.querySelector('[data-price]');
    var comparePriceEl = root.querySelector('[data-compare-price]');
    var discountEl = root.querySelector('[data-discount]');
    var priceSuffixEl = root.querySelector('[data-price-suffix]');
    var skuWrap    = root.querySelector('[data-sku-wrap]');
    var skuEl      = root.querySelector('[data-sku]');
    var qtyInput   = root.querySelector('[data-qty-input]');
    var formMessage = root.querySelector('[data-form-message]');
    var optionButtons = root.querySelectorAll('.product-page__option-value');
    var optionLabels  = root.querySelectorAll('[data-selected-value]');

    var purchaseOptions  = root.querySelectorAll('[data-purchase-option]');
    var frequencyList    = root.querySelector('[data-frequency-list]');
    var frequencyOptions = root.querySelectorAll('[data-frequency-option]');
    var sellingPlanInput = root.querySelector('[data-selling-plan-input]');

    var variants = [];
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
    }

    var currentVariant = null;
    var currentPlanId  = sellingPlanInput ? (frequencyOptions.length ? frequencyOptions[0].getAttribute('data-plan-id') : null) : null;
    var planMode = 'onetime';

    /* ─── Gallery: thumbnail click → scroll carousel ───────── */
    if (carousel && thumbs.length) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var mediaId = thumb.getAttribute('data-media-id');
          var slide = carousel.querySelector('[data-media-id="' + mediaId + '"]');
          if (slide) {
            carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          }
          setActiveThumb(mediaId);
        });
      });

      var scrollTimeout;
      carousel.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var scrollLeft = carousel.scrollLeft;
          var slides = carousel.querySelectorAll('.product-page__main-slide');
          var closest = null;
          var minDist = Infinity;
          slides.forEach(function (slide) {
            var dist = Math.abs(slide.offsetLeft - scrollLeft);
            if (dist < minDist) { minDist = dist; closest = slide; }
          });
          if (closest) setActiveThumb(closest.getAttribute('data-media-id'));
        }, 100);
      }, { passive: true });
    }

    function setActiveThumb(mediaId) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-id') === mediaId);
      });
    }

    function goToMedia(mediaId) {
      if (!carousel || !mediaId) return;
      var slide = carousel.querySelector('[data-media-id="' + mediaId + '"]');
      if (slide) {
        carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setActiveThumb(mediaId);
      }
    }

    /* ─── Simple hover zoom (desktop only) ──────────────────── */
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      root.querySelectorAll('[data-zoom-wrap]').forEach(function (wrap) {
        var img = wrap.querySelector('img');
        if (!img) return;
        wrap.addEventListener('mousemove', function (e) {
          var rect = wrap.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
          img.style.transform = 'scale(1.8)';
        });
        wrap.addEventListener('mouseleave', function () {
          img.style.transform = 'scale(1)';
        });
      });
    }

    /* ─── Purchase option (one-time vs subscribe) ───────────── */
    purchaseOptions.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        planMode = opt.getAttribute('data-plan-mode');

        purchaseOptions.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');

        if (frequencyList) {
          frequencyList.classList.toggle('is-visible', planMode === 'subscribe');
        }

        if (planMode === 'subscribe') {
          var selectedFreq = root.querySelector('[data-frequency-option].is-selected') || frequencyOptions[0];
          currentPlanId = selectedFreq ? selectedFreq.getAttribute('data-plan-id') : null;
          if (sellingPlanInput) {
            sellingPlanInput.disabled = false;
            sellingPlanInput.value = currentPlanId || '';
          }
        } else {
          currentPlanId = null;
          if (sellingPlanInput) {
            sellingPlanInput.disabled = true;
            sellingPlanInput.value = '';
          }
        }

        refreshPriceDisplay();
      });
    });

    frequencyOptions.forEach(function (freq) {
      freq.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        frequencyOptions.forEach(function (f) { f.classList.remove('is-selected'); });
        freq.classList.add('is-selected');
        currentPlanId = freq.getAttribute('data-plan-id');
        if (sellingPlanInput && planMode === 'subscribe') {
          sellingPlanInput.value = currentPlanId || '';
        }
        refreshPriceDisplay();
      });
    });

    /* ─── Variant selection ──────────────────────────────────── */
    var selectedOptions = [];
    var firstOptionGroup = root.querySelector('.product-page__option');
    if (firstOptionGroup) {
      var groups = root.querySelectorAll('.product-page__option');
      groups.forEach(function (group, idx) {
        var selectedBtn = group.querySelector('.product-page__option-value.is-selected');
        selectedOptions[idx] = selectedBtn ? selectedBtn.getAttribute('data-value') : null;
      });
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, idx) {
          return opt === selectedOptions[idx];
        });
      }) || null;
    }

    currentVariant = findVariant() || variants[0] || null;

    function refreshPriceDisplay() {
      if (!currentVariant) return;

      if (planMode === 'subscribe' && currentPlanId) {
        var allocation = (currentVariant.selling_plan_allocations || []).find(function (a) {
          return String(a.selling_plan_id) === String(currentPlanId);
        });
        if (allocation) {
          if (priceEl) priceEl.textContent = allocation.price;
          if (comparePriceEl) comparePriceEl.style.display = 'none';
          if (discountEl) discountEl.style.display = 'none';
          if (priceSuffixEl) {
            priceSuffixEl.textContent = '/ delivery';
            priceSuffixEl.style.display = '';
          }
          return;
        }
      }

      if (priceEl) priceEl.textContent = currentVariant.price;
      if (priceSuffixEl) priceSuffixEl.style.display = 'none';
      if (comparePriceEl) {
        if (currentVariant.compare_at_price) {
          comparePriceEl.textContent = currentVariant.compare_at_price;
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (discountEl) {
        if (currentVariant.discount_percent > 0) {
          discountEl.textContent = '-' + currentVariant.discount_percent + '%';
          discountEl.style.display = '';
        } else {
          discountEl.style.display = 'none';
        }
      }
    }

    function updateUI(variant) {
      if (!variant) return;
      currentVariant = variant;

      if (variantIdInput) variantIdInput.value = variant.id;

      if (skuWrap && skuEl) {
        if (variant.sku) {
          skuEl.textContent = variant.sku;
          skuWrap.style.display = '';
        } else {
          skuWrap.style.display = 'none';
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
      }
      if (btnText) {
        btnText.textContent = variant.available ? (window.__ppAddToCartText || 'Add to Cart') : 'Sold Out';
      }

      if (variant.featured_media_id) {
        goToMedia(String(variant.featured_media_id));
      }

      refreshPriceDisplay();

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-value');

        selectedOptions[idx] = value;

        var group = btn.closest('.product-page__option');
        group.querySelectorAll('.product-page__option-value').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        if (optionLabels[idx]) optionLabels[idx].textContent = value;

        var matched = findVariant();
        if (matched) updateUI(matched);
      });
    });

    if (btnText) window.__ppAddToCartText = btnText.textContent.trim();

    /* ─── Quantity +/- ───────────────────────────────────────── */
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus  = root.querySelector('[data-qty-plus]');
    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    /* ─── Add to Cart ────────────────────────────────────────────
       Header already owns a document-level submit listener that
       catches every form posting to /cart/add and handles fetch +
       drawer open + cart render. We must NOT intercept submit here
       too — that caused double-adds and a broken/empty drawer
       before. Just show a brief spinner and let it bubble. ────── */
    if (form && addBtn) {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;

    addBtn.classList.add('is-loading');

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        addBtn.classList.remove('is-loading');

        if (data.status) {
          console.error('Add to cart error:', data.description || data.message);
          if (formMessage) {
            formMessage.textContent = data.description || 'Could not add to cart.';
            formMessage.className = 'product-page__message product-page__message--error is-visible';
          }
          return;
        }

        document.dispatchEvent(
          new CustomEvent('product-card:added', { detail: { item: data, form: form } })
        );
      })
      .catch(function (err) {
        addBtn.classList.remove('is-loading');
        console.error('Add to cart failed:', err);
      });
  });
}

    /* ─── Accordion ──────────────────────────────────────────── */
    root.querySelectorAll('.accordion__item').forEach(function (item) {
      var trigger = item.querySelector('.accordion__trigger');
      var content = item.querySelector('.accordion__content');
      if (!trigger || !content) return;

      if (item.classList.contains('is-open')) {
        content.style.maxHeight = 'none';
      }

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (isOpen) {
          content.style.maxHeight = content.scrollHeight + 'px';
          requestAnimationFrame(function () {
            content.style.maxHeight = '0px';
          });
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          content.style.maxHeight = content.scrollHeight + 'px';
          trigger.setAttribute('aria-expanded', 'true');

          var handler = function () {
            if (item.classList.contains('is-open')) {
              content.style.maxHeight = 'none';
            }
            content.removeEventListener('transitionend', handler);
          };
          content.addEventListener('transitionend', handler);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.product-page').forEach(initProductPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.product-page');
    if (s) initProductPage(s);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
